export class NWSVolumeRoutes
{
    static Home: string = "/";
    // volume
    static VolumeList: string = "/volume/list";
    static VolumeNew: string = "/volume/new";
    static VolumeView(id: string)
    {
        return `/volume/${id}/view`;
    }
    static VolumeEdit(id: string)
    {
        return `/volume/${id}/edit`;
    }
    static VolumeCopy(id: string)
    {
        return `/volume/${id}/copy`;
    }
}